import React from 'react'
import { Translate } from "react-redux-i18n";

const CircleStatus=({circle})=> {
  const status_class={
    member_gathering: 'incomplete',
    awaiting_commitment: 'incomplete',
    awaiting_purchase: 'incomplete',
    pending: 'pending',
    completed: 'completed'
  }
  
  return (
    <div className={`product-completion ${status_class[circle.status]}`}>
        <Translate value={`circle_status.${circle.status}`} />
    </div>
  )
}
export  default CircleStatus;